import { Layout, Menu, Spin } from "antd";
import { useEffect, useState } from "react";
import { MenuItem, getOpenKeys, items } from "./helpers";
import { useLocation, useNavigate } from "react-router-dom";
import { sideBarRoutesObjectBasedOnKeys, sidebarRoutes } from "./constants";
import { useCurrentUserContext } from "providers";
import styles from "./styles.module.scss";
import { ENVIORNMENTS, getCurrentEnviornment } from "utils/constants";
import { Tabs } from "./Tabs";
import { SandboxIcon } from "icons";
import { ConditionalRenderer } from "components/conditonal-renderer";
import { LiveIcon } from "icon-components";
import Cookies from "js-cookie";
import { UseLazyApiCallV2 } from "hooks";

const { Sider } = Layout;
const { SubMenu } = Menu;

export function SideNavbar() {
  const [collapsed, setCollapsed] = useState(false);
  const [activeKey, setActiveKey] = useState<string | null>("1");

  const [openKeys, setOpenKeys] = useState<string[] | undefined>([]);

  const [loading, setLoading] = useState(false);
  const { LIVE, SANDBOX, ENVIORNMENT } = ENVIORNMENTS;

  const currentEnviornment = getCurrentEnviornment();
  const newEnviornment = currentEnviornment === LIVE ? SANDBOX : LIVE;
  const [getData] = UseLazyApiCallV2({
    method: "POST",
    url: "/logout_user",
  }) as any;

  const tabsArr = [
    {
      title: "Live",
      key: "live",
      icon: LiveIcon,
      color: "black",
      activeColor: "white",
    },
    {
      title: "Sandbox",
      key: "sandbox",
      icon: SandboxIcon,
    },
  ];

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user, saveUserData } = useCurrentUserContext();

  useEffect(() => {
    const activeKey: string = sidebarRoutes[pathname];

    setActiveKey(activeKey);
    setOpenKeys(getOpenKeys(activeKey));
  }, [pathname]);
  const tonalItemInSidebar =
    user?.role === "intern" ? [] : items[items.length - 1];

  const filteredItems: MenuItem[] =
    items
      .filter((item) => user?.projects?.includes(item.label))
      .concat(tonalItemInSidebar) || [];

  const sandboxItems = items.filter((item) =>
    user?.projects?.includes(item.label),
  );

  const finalItemsToDisplay =
    currentEnviornment === ENVIORNMENTS.LIVE ? filteredItems : sandboxItems;

  const handleMenuItemClick = (key: React.Key) => {
    const keyString: string = key.toString();
    // setActiveKey(keyString);
    // setOpenKeys(getOpenKeys(key));
    const activeRoutObj: { [route: string]: string } =
      sideBarRoutesObjectBasedOnKeys[keyString];

    let sourceDashboard = activeRoutObj?.sourceDashoard; // Define source dashboard variable
    let baseRoute = activeRoutObj?.baseRoute; // Define base route variable

    navigate(`${baseRoute}`, { state: { sourceDashboard } });
  };

  const handleChangeEnviornment = async (newEnviornment: any) => {
    if (localStorage.getItem(`${newEnviornment}_userId`)) {
      navigate("m2c-dashboard");
      window.location.reload();
    } else {
      navigate("/");
      window.location.reload();
    }

    // Cookies.remove(`${getCurrentEnviornment()}_sessionToken`);
    // localStorage.removeItem(`${getCurrentEnviornment()}_userId`);
    // localStorage.removeItem(`${getCurrentEnviornment()}_userEmail`);
    // setLoading(true);
    // try {
    //   await getData({
    //     params: {
    //       secret_id: user?.secret_id,
    //     },
    //   });
    // } catch (error) {
    // } finally {
    //   setLoading(false);
    //   navigate("/");
    //   localStorage.setItem(ENVIORNMENT, newEnviornment);
    //   window.location.reload();
    // }

    // saveUserData(null);
  };

  useEffect(() => {
    if (window.innerWidth <= 576) {
      setCollapsed(true);
    }
  }, []);

  return (
    <>
      <Sider
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        width={270}
        className={styles["side-navbar"]}
      >
        <div className={styles["side-nav-logo-Container"]}>
          <img
            src="/assets/logos/sideNavLogo.svg"
            alt="Motion2Coach"
            className={styles["side-nav-logo"]}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            height: "calc(100dvh - 160px)",
          }}
        >
          <Menu
            theme="light"
            mode="inline"
            style={{ color: "black" }}
            selectedKeys={[activeKey] as any}
            openKeys={openKeys}
            onOpenChange={(openKey) => setOpenKeys(openKey)}
            defaultSelectedKeys={[activeKey] as any} // Set default selected key
          >
            {finalItemsToDisplay.map((item: any) => {
              const childrenForIntern = item.children?.filter(
                (item: any) => item?.label === "History",
              );
              const childrenForAdmin = item.children?.filter(
                (item: any) => item?.label,
              );
              const childs =
                user?.role === "intern" ? childrenForIntern : childrenForAdmin;

              return item.children ? (
                <SubMenu
                  key={item.key}
                  icon={item.icon}
                  title={
                    item.label === "Motion2Coach Simulation"
                      ? "Kinebase"
                      : item.label
                  }
                  style={{ color: " black" }}
                  disabled={item.key === "2"}
                >
                  {childs.map((child: any) => (
                    <Menu.Item
                      key={child.key}
                      onClick={() => handleMenuItemClick(child.key)}
                    >
                      {child.label}
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item
                  key={item.key}
                  icon={item.icon}
                  onClick={() => handleMenuItemClick(item.key)}
                >
                  {item.label}
                </Menu.Item>
              );
            })}
          </Menu>
          {/* <ConditionalRenderer condition={user?.switch}>
            <Spin spinning={loading}>
              <div>
                <Tabs
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  tabsArr={tabsArr}
                  handleClick={handleChangeEnviornment}
                />
              </div>
            </Spin>
          </ConditionalRenderer> */}
        </div>
      </Sider>
    </>
  );
}
